import { Flex } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const ChartLegendWrapper = styled(Flex)`
  list-style-type: none;
  padding: 0;
  margin: 0;
  justify-content: end;
  gap: 32px;
`

export const ChartLegendItem = styled(Flex)`
  align-items: center;
  gap: 6px;
`
